import React, { FC, forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core';
import CheckmarkSvg from 'assets/svgs/led-landing/CheckmarkSvg.svg';
import CommercialIconSvg from 'assets/svgs/led-landing/CommercialIconSvg.svg';
import ResidentialIconSvg from 'assets/svgs/led-landing/ResidentialIconSvg.svg';
import IosDownloadIconSvg from 'assets/svgs/led-landing/IosDownloadIconSvg.svg';
import AndroidDownloadIconSvg from 'assets/svgs/led-landing/AndroidDownloadIconSvg.svg';
import ContinueOnWebIconSvg from 'assets/svgs/led-landing/ContinueOnWebIconSvg.svg';

export const Checkmark: FC<SvgIconProps> = forwardRef((props, ref) => (
  <CheckmarkSvg ref={ref} {...props} />
));

export const CommercialIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <CommercialIconSvg ref={ref} {...props} />
));

export const ResidentialIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <ResidentialIconSvg ref={ref} {...props} />
));

export const IosDownloadIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <IosDownloadIconSvg ref={ref} {...props} />
));

export const AndroidDownloadIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <AndroidDownloadIconSvg ref={ref} {...props} />
));

export const ContinueOnWebIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <ContinueOnWebIconSvg ref={ref} {...props} />
));
